<template>
  <ul class="facets-group ranked">
    <li v-for="facet of facets" :key="facet.slug">
      <base-checkbox
        :name="facet.slug"
        :model-value="selectedFacets.includes(facet.slug)"
        :disabled="!isFacetActive(facet.slug)"
        @update:model-value="facetChange(facet.slug, $event)"
      >
        {{ facet.name }}
        <span
          v-show="searchWizardStore.showCount && isFacetActive(facet.slug)"
          class="count"
        >
          {{ counts[facet.slug] }}
        </span>
      </base-checkbox>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Facet {
  name: string
  slug: string
}

interface FacetGroup {
  name: string
  slug: string
  facets: Facet[]
  hideEmpty: boolean
}

const props = defineProps<{
  group: FacetGroup
  counts: Record<string, number>
  initialFacetCounts: Record<string, number>
  selectedFacets: string[]
}>()

const searchWizardStore = useSearchWizardStore(usePinia())

const emit = defineEmits(['facetsChange'])

const facets = computed(() => props.group.facets)

function isFacetActive(slug: string): boolean {
  return (
    !searchWizardStore.showCount ||
    (!!props.counts[slug] && !facetsBelowSelected.value.includes(slug))
  )
}

function facetChange(changedSlug: string, checked: boolean) {
  const newSelected = facetSlugs.value.map((slug) => [
    slug,
    slug === changedSlug ? checked : false,
  ])
  emit('facetsChange', newSelected)
}

const facetSlugs = computed<string[]>(() => {
  return props.group.facets.map(({ slug }) => slug)
})

const facetsBelowSelected = computed(() => {
  const selectedFacetIndex = facetSlugs.value.findIndex((slug: string) =>
    props.selectedFacets.includes(slug),
  )
  return selectedFacetIndex > -1
    ? props.group.facets.slice(selectedFacetIndex + 1).map(({ slug }) => slug)
    : []
})
</script>
